import React from "react";
import {
  Row,
  Col,
  Space,
  Tooltip,
  message,
  Button,
  Modal,
  Image,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import ListTable from "./ListTable";
import config from "../config";
import withRouter from "../withRouter";
import { CloseOutlined } from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import PointofInterestAdd from "./PointofInterestAdd";
import PointofInterest from "../store/PointofInterestStore";
import CompanyStore from "../store/CompanyStore";
import { Link } from "react-router-dom";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";

class AdvertisementList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.poiStore = new PointofInterest(this);
    this.companyStore = new CompanyStore(this);
    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      loadData: 1,
      companyId: "",
      comp_value: "",
      openPOIForm: false,

      openDeleteModal: false,
      deleteData: {},
    };

    this.columns = [
      {
        title: context.translate("_COMAPNY_NAME_"),
        dataIndex: "companyName",
        width: 20,
        ellipsis: {
          showTitle: true,
        },
        render: (val, record) => {
          return (
            <Tooltip placement="topLeft" title={val}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("poiList") && this.onEdit(record);
                }}
              >
                {val}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        title: context.translate("_NAME_"),
        dataIndex: "poiname",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_SEQUENCE_"),
        dataIndex: "sequence",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_INTERVAL_SEC_"),
        dataIndex: "playInterval",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_IMAGE_VIDEO_TYPE_"),
        dataIndex: "showType",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          if (value === "1") {
            return "Full Banner";
          }
          if (value === "2") {
            return "Middle Banner";
          }
          if (value === "3") {
            return "Bottom Banner";
          }
        },
      },
      {
        title: context.translate("_DESCRIPTION_"),
        dataIndex: "description",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: context.translate("_PICTURE_VIEW_"),
        dataIndex: "path",
        width: 30,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          var imagePath = config.fleetURL + record.path;
          var showType = Number(record.showType);
          var isImgVideo = Number(record.isImgVideo);
          if (showType === 1 && isImgVideo === 1) {
            return (
              <img
                src={imagePath}
                alt="Image"
                style={{ width: "100px", height: "auto" }}
              />
            );
          }
          if (showType === 2 && isImgVideo === 1) {
            return (
              <img
                src={imagePath}
                alt="Image"
                style={{ width: "100px", height: "auto" }}
              />
            );
          }
          if (showType === 3 && isImgVideo === 1) {
            return (
              <img
                src={imagePath}
                alt="Image"
                style={{ width: "100px", height: "auto" }}
              />
            );
          }
          if (isImgVideo === 2) {
            //return "<img src=" + imagePath + " height='70px' width ='70px'></img>";
            return (
              <video width="280" height="70" controls>
                <source src={imagePath} type="video/mp4" />
              </video>
            );
          }
        },
      },
      {
        title: context.translate("_ACTION_"),
        dataIndex: "action",
        width: 6,
        ellipsis: {
          showTitle: true,
        },
        render: (_, record) => {
          return (
            <>
              <Space>
                {this.props.canUpdate("poiList") && (
                  <Tooltip
                    title={this.context.translate("_EDIT_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      style={{
                        height: "19px",
                        width: "15px",
                        borderRadius: "0px",
                        cursor: "pointer",
                      }}
                      src={editIcon}
                      onClick={async (e) => {
                        e.preventDefault();
                        await this.onEdit(record);
                      }}
                    ></Image>
                  </Tooltip>
                )}
                {this.props.canDelete("poiList") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer", width: "15px" }}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
              </Space>
            </>
          );
        },
      },
    ];

    let columns = this.columns;
    let isadmin = this.props.getUserData().isadmin;
    if (isadmin === 1) {
      columns = this.columns.filter((val) => val.dataIndex !== "action");
    }

    this.columns = columns;
  }
  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      let setPOIData = this.context.viewStateStore.poiObject;

      setPOIData =
        typeof setPOIData === "number" ? setPOIData : setPOIData.companyId;

      if (setPOIData !== "") {
        await this.poiStore.loadData({
          companyId: setPOIData,
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          page: this.state.currentPage,
        });

        const singleData = await this.companyStore.getCompanyDataById(
          setPOIData
        );

        await this.setState({ loadList: 1 });

        await this.setState({
          comp_value: singleData,
          companyId: setPOIData,
        });
      }
      await this.setState({ listDataUpdate: false });
    }
  }

  onEdit = async (record) => {
    await this.context.viewStateStore.setpoiStates({
      companyId: record.companyId,
    });
    await this.setState({ id: record.id });
    await this.setState({ openPOIForm: true });
  };

  async onDelete(record) {
    const response = await this.poiStore.deleteRecord({
      id: record.id,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }

  async handleSearch() {
    this.setState({ loading: true });
    if (this.state.companyId > 0) {
      await this.poiStore.loadData({
        companyId: this.state.companyId,
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        page: this.state.currentPage,
      });
      await this.setState({ loadData: 1, loading: false });
    }
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      currentPage: 1,
      pageSize: 50,
    });

    const singleData = await this.companyStore.getCompanyDataById(comp.value);

    await this.setState({ comp_value: singleData });

    await this.handleSearch();
    await this.setState({ loadList: 1 });
  }

  closeModal = () => {
    this.setState({ openPOIForm: false });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    if (this.state.companyId) {
      await this.poiStore.loadData({
        companyId: this.state.companyId,
        offset: 0,
        limit: 50,
      });
    }
    this.setState({ loading: false, currentPage: 1 });
  };

  responseMsg = async (resp) => {
    if (resp.success === "S") {
      message.success(resp.message);
      await this.setState({ listDataUpdate: true });
      await this.setState({ openPOIForm: false });
      await this.handleSearch();
    } else {
      message.error(resp.message);
    }
  };

  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  style={{ width: 200 }}
                  value={this.state.comp_value ? this.state.comp_value : null}
                />
              </Space>
            </Col>
            <Col
              span={8}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    alignItems: "center",
                    cursor: "pointer",
                    marginInlineEnd: "20px",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>

              {this.props.canCreate("poiList") && (
                <Button
                  className="addButtonClass"
                  onClick={() => this.setState({ openPOIForm: true, id: "" })}
                >
                  <Image
                    style={{ marginInlineEnd: "5px", width: 13 }}
                    src={require("../assets/images/NewDesign/plus (Stroke).png")}
                  ></Image>
                  {this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                </Button>
              )}
            </Col>
          </Row>
          <ListTable
            currentPage={this.state.currentPage}
            total={this.poiStore?.total}
            columns={this.columns}
            pageSize={this.state.pageSize}
            dataSource={this.poiStore?.poiList}
            loading={this.poiStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openPOIForm && (
          // <Modal
          //   bodyStyle={{ height: "645px" }}
          //   className="formShowModal"
          //   title={this.context.translate("_ADD_POI_")}
          //   centered
          //   open={this.state.openPOIForm}
          //   footer={null}
          //   onCancel={() => {
          //     this.setState({ openPOIForm: false, id: "" });
          //   }}
          //   width={665}
          // >

          <Drawer
            className="uploadExcelDrawer"
            width={716}
            closeIcon={false}
            open={this.state.openPOIForm}
            placement={this.context.locale.language === "english" ? "right" : "left"}
            footer={false}
            title={
              <div className="formTitle">
                {this.context.translate("_ADD_POI_")}
                <p className="formDescription">
                  {this.context.translate("_POINT_OF_INTEREST_DESC_")}
                </p>
              </div>
            }
            maskClosable={false}
            onOk={() => this.setState({ openPOIForm: false })}
            onCancel={() => this.setState({ openPOIForm: false, id: "" })}
          >
            <div style={{ height: "100%" }}>
              <PointofInterestAdd
                companyId={this.state.companyId}
                id={this.state.id}
                response={this.responseMsg}
                closeModal={this.closeModal}
              />
            </div>
          </Drawer>
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
AdvertisementList.contextType = StoreContext;
export default observer(withRouter(AdvertisementList));
